export class App {
    id: string;
    nombre: string;
    descripcion: string;
    imageUrl:string;
    avatarUrl:string;
    isActivaApi:boolean;
    isActivaDB:boolean;
    numUsuarios:number;

    entryPoint:string;
    apiKey:string;
}